<template>
  <div class="mx-10">
    <v-tabs v-model="activeTab" color="#00B3FF">
      <v-tab v-if="hasPermission('setting.company_settings')">Company Settings</v-tab>
      <v-tab-item>
        <CompanySettings v-if="hasPermission('setting.company_settings')" />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import CompanySettings from "@/components/settings/CompanySettings";
const { mapGetters } = createNamespacedHelpers("auth");
import { createNamespacedHelpers } from "vuex";

export default {
  name: "Setting",
  components: {
      CompanySettings,
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      profile: "profile",
      hasPermission: "hasPermission",
    }),
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
  },
};
</script>
